export const ONLINE_THRESHOLD_MINUTES = 5;
export const ONLINE_THRESHOLD_MS = ONLINE_THRESHOLD_MINUTES * 60 * 1000;

export const STALE_THRESHOLD_MINUTES = 60;
export const STALE_THRESHOLD_MS = STALE_THRESHOLD_MINUTES * 60 * 1000;

const formatElapsedLabel = (diffMs) => {
  const totalMinutes = Math.floor(diffMs / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours <= 0) {
    return `${Math.max(totalMinutes, 0)}m ago`;
  }

  return `${hours}h ${minutes}m ago`;
};

export const resolveDeviceStatus = (device) => {
  if (!device?.is_active) {
    return {
      status: "disabled",
      label: "Disabled",
      color: "#DC2626",
    };
  }

  if (!device?.last_seen) {
    return {
      status: "offline",
      label: "Offline (never seen)",
      color: "#6B7280",
    };
  }

  const lastSeenMs = Date.parse(device.last_seen);
  if (!Number.isFinite(lastSeenMs)) {
    return {
      status: "unknown",
      label: "Unknown (invalid timestamp)",
      color: "#64748B",
    };
  }

  const diffMs = Math.max(0, Date.now() - lastSeenMs);

  if (diffMs <= ONLINE_THRESHOLD_MS) {
    return {
      status: "online",
      label: "Online",
      color: "#16A34A",
    };
  }

  if (diffMs <= STALE_THRESHOLD_MS) {
    return {
      status: "stale",
      label: `Stale (${formatElapsedLabel(diffMs)})`,
      color: "#B45309",
    };
  }

  return {
    status: "offline",
    label: `Offline (${formatElapsedLabel(diffMs)})`,
    color: "#6B7280",
  };
};
